import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance } from 'vue';
import { getAirport } from '@white-label-helper/get-airport-composable';
// Types
import type { CartItem, Item } from '@white-label-types/parking-checkout';
import useDepositStore from "@white-label-store/deposits";

type SummaryElement = CartItem | Item;
interface Props {
  product: SummaryElement;
  isRefund?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'summary-airport',
  props: {
    product: null,
    isRefund: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { product: SummaryElement, isRefund: boolean };

const instance = getCurrentInstance();
const proxy = instance?.proxy as Vue;



const depositStore = useDepositStore();
const { airport } = getAirport(props.product);

const hasDeposit = computed(() => {
  if (depositStore.cartTotalDepositAmount === null) {
    return false;
  }
  return depositStore.cartTotalDepositAmount;
});

const airportLabel = computed(() => {
  let label = `${airport.value.name} (${airport.value.code})`;

  if (hasDeposit.value && !props.isRefund && !proxy.isMobileResolution) {
    label += ` ${proxy.$t('shared.payOnArrival')}`;
  }

  return label;
});

return { __sfc: true,instance, proxy, props, depositStore, airport, hasDeposit, airportLabel }
}

})